"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validate = void 0;
var validate = function (response, allowNoResponse, validation) {
    if (allowNoResponse && response.length === 0) {
        return;
    }
    else if (response.length === 0) {
        return {
            response: 'Please enter a response',
        };
    }
    if (!validation) {
        return;
    }
    if (Array.isArray(response)) {
        for (var res in response) {
            var notValid = exports.validate(res, allowNoResponse, validation);
            if (notValid) {
                return notValid;
            }
        }
        return;
    }
    if (validation.answerType === 'year' || validation.answerType === 'year-not-future') {
        var isNumbers = /^\d+$/.test(response);
        if (!isNumbers || response.length !== 4) {
            return {
                response: 'Please enter a year (YYYY)',
            };
        }
        if (validation.answerType === 'year-not-future') {
            var year = new Date(response).getUTCFullYear();
            var currentYear = new Date().getUTCFullYear();
            if (year > currentYear) {
                return {
                    response: 'Please enter a year not in the future',
                };
            }
        }
        return;
    }
    if (validation.answerType === 'number' && !/^\d+$/.test(response)) {
        return {
            response: 'Please enter a number',
        };
    }
    if (validation.max && response.length > validation.max) {
        return {
            response: "Maximum characters is " + validation.max,
        };
    }
    if (validation.min && response.length < validation.min) {
        return {
            response: "Minimum characters is " + validation.min,
        };
    }
};
exports.validate = validate;
